import React, { useEffect, useState } from "react";
import "../../styles/styles.css";
import "../../styles/layout.css";
import LeaveBalanceChart from "./LeaveBalance_Chart";
import LeaveBalanceList from "./LeaveBalance_List";
import { getUserInfoFromToken } from "../../utils/authUtils";

const LeaveBalance = () => {
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    const { userType: type } = getUserInfoFromToken();
    setUserType(type);
  }, []);

  if (userType === "Employee") {
    return <LeaveBalanceChart />;
  }

  if (userType === "Employer") {
    return <LeaveBalanceList />;
  }

  if (userType === "Admin") {
    return <LeaveBalanceList />;
  }

  return null;
};

export default LeaveBalance;
